import React from 'react';
import s from './s.module.less';
import { Prospect, ProspectNotesItem } from 'types/common';
import { getTimeStr } from 'utils/calendar';
import dayjs from 'utils/dayjs';
import { Button, Spin, message } from 'antd';
import { useRequest } from 'ahooks';
import { createProspectNote, getProspectNoteList } from 'api/prospect';
import TextArea from 'antd/lib/input/TextArea';

type Props = {
    prospect?: Prospect,
    hasBanner: boolean,
};

const Page = (props: Props) => {
    const { prospect, hasBanner } = props;
    const [content, setContent] = React.useState('');
    const { data, loading, run } = useRequest(getProspectNoteList, {
        manual: true,
    });
    const prospectId = prospect?.id;

    React.useEffect(() => {
        if (prospectId) {
            run(prospectId);
        }
    }, [prospectId]);

    const list: ProspectNotesItem[] = data?.data?.data || [];
    list.sort((a, b) => {
        return new Date(b.createTime).getTime() - new Date(a.createTime).getTime();
    });

    const sendEmail = async () => {
        const result = await createProspectNote(prospectId!, content);
        if (result.error) {
            //message.error(result.error);
        } else {
            message.success('Noted added');
            setContent('');
            run(prospectId!);
        }
    };

    //todo
    const isSample = prospect?.isSample;

    return (
        <div className={`${s.wrap} ${hasBanner ? s.wrapWithBanner : ''}`}>
            {
                !isSample &&
                <Spin spinning={loading} style={{ height: 48, width: '100%', position: 'absolute' }} />
            }
            <div className={s.listWrap}>
                {
                    isSample && (
                        <div className={s.tipsSample}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.25706 3.09956C9.02167 1.74025 10.9788 1.74025 11.7434 3.09956L17.3237 13.0201C18.0736 14.3533 17.1102 16.0006 15.5805 16.0006H4.4199C2.89025 16.0006 1.92682 14.3533 2.67675 13.0201L8.25706 3.09956ZM11.0001 13.0007C11.0001 13.553 10.5524 14.0007 10.0001 14.0007C9.44784 14.0007 9.00012 13.553 9.00012 13.0007C9.00012 12.4484 9.44784 12.0007 10.0001 12.0007C10.5524 12.0007 11.0001 12.4484 11.0001 13.0007ZM10.0001 5.00073C9.44784 5.00073 9.00012 5.44845 9.00012 6.00073V9.00073C9.00012 9.55302 9.44784 10.0007 10.0001 10.0007C10.5524 10.0007 11.0001 9.55302 11.0001 9.00073V6.00073C11.0001 5.44845 10.5524 5.00073 10.0001 5.00073Z" fill="#FBBF24" />
                            </svg>
                            Notes feature is disabled as this is a sample client
                        </div>
                    )
                }
                {
                    list.map((msg: ProspectNotesItem, inx) => {
                        return (
                            <div className={s.msg}>
                                <div className={s.msgHeader}>
                                    <div className={s.left}>
                                        <div className={s.title}>{inx + 1}</div>
                                    </div>
                                    <div className={s.right}>
                                        {getTimeStr(dayjs(msg.createTime), 'dddd MMM DD, [at] hh:mm A')}
                                    </div>
                                </div>
                                <div className={s.msgContent}>
                                    {msg.notes}
                                </div>
                            </div>
                        );
                    })
                }
            </div>
            <div className={s.replyWrap}>
                <h4>New notes</h4>
                <TextArea
                    onChange={(e) => {
                        setContent(e.target.value);
                    }}
                    rows={3}
                    disabled={hasBanner || isSample}
                    value={content}
                />
                <Button
                    disabled={!content}
                    className={s.btn}
                    type="primary"
                    onClick={sendEmail}
                >Add
                </Button>
            </div>
        </div>
    );
};

export default Page;
